import { HTTP } from '../../utils'

export const getStreamDetail = (uuid) => {
  return HTTP().get('entity/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}
export const getStreamDetailByUserId = (userId) => {
  return HTTP().get('entity/user/' + userId + '/stream')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}
export const setLockStreamTrue = (uuid) => {
  return HTTP().put('entity/' + uuid + '/lock')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const setLockStreamFalse = (uuid) => {
  return HTTP().put('entity/' + uuid + '/unlock')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getStreamPlannerView = (uuid) => {
  return HTTP().get('entity/plannerView/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const doCsvUploadForStudentStream = (institutionId, createdByUuid, fileData) => {
  if (!institutionId || !createdByUuid) {
    return
  }
  let url = '/entity/studentAutoStream?createdByUuid=' + createdByUuid + '&institutionId=' + institutionId
  return HTTP().post(url, fileData)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const doCsvUploadForAlumniStream = (institutionId, createdByUuid, fileData) => {
  if (!institutionId || !createdByUuid) {
    return
  }
  let url = '/entity/alumniAutoStream?createdByUuid=' + createdByUuid + '&institutionId=' + institutionId
  return HTTP().post(url, fileData)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const doCsvUploadForAdvisorStream = (institutionId, createdByUuid, folderId, fileData) => {
  if (!institutionId || !createdByUuid || !folderId || !fileData) {
    return
  }
  let url = '/entity/advisorStream/upload/?createdByUuid=' + createdByUuid + '&institutionId=' + institutionId + '&folderId=' + folderId
  return HTTP().post(url, fileData)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const doCsvUploadForCourseOptions = (institutionId, createdByUuid, fileData) => {
  if (!institutionId || !createdByUuid) {
    return
  }
  let url = '/programguide/coursesAvailableUpload?createdByUuid=' + createdByUuid + '&institutionId=' + institutionId
  return HTTP().post(url, fileData)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const putCsvUploadForInstitutionCareers = (institutionId, createdByUuid, fileData) => {
  if (!institutionId || !createdByUuid) {
    return
  }
  let url = '/institutionCareer/csvUpload?createdByUuid=' + createdByUuid + '&institutionId=' + institutionId
  return HTTP().post(url, fileData)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const doCsvUploadForAARRequirements = (institutionId, createdByUuid, fileData) => {
  if (!institutionId || !createdByUuid) {
    return
  }
  let url = '/aar/requirement/requirementUpload?createdByUuid=' + createdByUuid + '&institutionId=' + institutionId
  return HTTP().post(url, fileData)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getAlumniStreamRecommendations = (recommendationData) => {
  if (!recommendationData) {
    return
  }
  let url = '/recommendation/alumniStreams'
  return HTTP().post(url, recommendationData)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getAdvisorStreamRecommendations = (recommendationData) => {
  if (!recommendationData) {
    return
  }
  let url = '/recommendation/advisorStreams'
  return HTTP().post(url, recommendationData)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const streamToCsvFile = (uuid) => {
  if (!uuid) {
    return
  }
  let url = '/entity/advisorStream/' + uuid + '/export'
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getStudentSpecialNotes = () => {
  return HTTP().get('/aar/requirement/specialnotes')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const updateEntityVerification = (entity) => {
  return HTTP().put('entity/' + entity.uuid + '/updateEntityVerification', entity)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}



// WEBPACK FOOTER //
// ./src/app/stream/api.js